<template>
<div>
  <v-subheader class='overline pl-0' v-if='label' v-text="label" />
  <v-menu >
    <template v-slot:activator="{ on }">
      <v-btn outlined v-on='on' slot='activator' :color='value' >
        <v-progress-circular v-if='loading' size=24 width='2' :color='value' class="mr-2" indeterminate />
        <v-avatar small icon
          v-else
          :class='value' class='mr-2' :size='size' />
        {{ btnText }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for='color in colors' :key='color'
        @click='setSelected(color)' >
        <v-list-item-content>
          <v-list-item-title>
            <v-avatar :class='color' :size=15 />
            {{color}}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
  <div v-if='hint' class='caption grey--text mt-2' v-text='hint' ></div>
</div>
</template>

<script >
const COLORS = [
  'red',
  'pink',
  'purple',
  'deep-purple',
  'indigo',
  'blue',
  'light-blue',
  'cyan',
  'teal',
  'green',
  'light-green',
  'lime',
  'yellow',
  'amber',
  'orange',
  'deep-orange',
  'brown',
  'blue-grey',
  'grey',
]
export default {
  name: 'ColorPicker',
  props: {
    value: { type: String, required: false },
    label: { type: String, required: false },
    hint: { type: String, required: false },
    size: { type: Number, required: false, default: 12 },
    attrs: { type: Object, required: false },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      colors: COLORS,
      selected: null
    }
  },
  computed: {
    member () {
      return this.value
    },
    btnText () {
      if (this.value) { return this.value }
      return 'Choose a color'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.selected = this.value }
      }
    }
  },
  methods: {
    setSelected (color) {
      this.selected = color
      this.$emit('input', this.selected)
    }
  }
}
</script>
